import { render, staticRenderFns } from "./reference-invoice.vue?vue&type=template&id=b5e0039e&scoped=true"
import script from "./reference-invoice.vue?vue&type=script&lang=js"
export * from "./reference-invoice.vue?vue&type=script&lang=js"
import style0 from "./reference-invoice.vue?vue&type=style&index=0&id=b5e0039e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e0039e",
  null
  
)

export default component.exports